export const isBeforePullinTime = (pullInTime) => {
  const formatTime = (timeStr) => {
    const [time, period] = timeStr.split(" ");
    let [hours, minutes] = time.split(":").map(Number);
    if (period === "P" && hours !== 12) hours += 12; // Convert PM to 24-hour format
    if (period === "A" && hours === 12) hours = 0; // Convert 12 AM to 0 hours
    if (period === "X") hours += 24; // Next day time
    return hours * 60 + minutes; // Convert time to minutes past midnight
  };

  const getCurrentTimeInMinutes = () => {
    const now = new Date();
    return now.getHours() * 60 + now.getMinutes();
  };

  const currentTimeInMinutes = getCurrentTimeInMinutes();
  const pullInTimeInMinutes = formatTime(pullInTime);

  return pullInTimeInMinutes > currentTimeInMinutes;
};
